import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "widget edit-card" }
const _hoisted_3 = { class: "form-grid" }
const _hoisted_4 = { class: "form-field-floating lg reactive active" }
const _hoisted_5 = { class: "form-field-floating lg reactive active" }
const _hoisted_6 = { class: "form-grid" }
const _hoisted_7 = { class: "form-field-floating lg reactive active" }
const _hoisted_8 = { class: "form-field-floating lg reactive active" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success mt-4"
}
const _hoisted_10 = {
  key: 1,
  class: "alert alert-error mt-4"
}
const _hoisted_11 = { class: "form-actions" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_phone_input = _resolveComponent("custom-phone-input")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "page-header" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", {
          class: "secondary-font font-semibold",
          style: {"margin":"0"}
        }, "Informations personnelles"),
        _createElementVNode("p", {
          class: "text-sm text-grey-600",
          style: {"margin":"0.25rem 0 0"}
        }, "Consultez et modifiez vos informations personnelles.")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSaveInfo && _ctx.handleSaveInfo(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "nom",
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nom) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.nom]
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("label", { for: "nom" }, [
                _createTextVNode("Nom "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "prenom",
                type: "text",
                class: "form-input",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.prenom) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.prenom]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", { for: "prenom" }, [
                _createTextVNode("Prénom "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                class: "form-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.email) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _ctx.formData.email]
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("label", { for: "email" }, [
                _createTextVNode("Adresse email "),
                _createElementVNode("b", { class: "color-danger" }, "*")
              ], -1))
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_custom_phone_input, {
              modelValue: _ctx.formData.telephone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.telephone) = $event)),
              id: "telephone"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            id: "fonction",
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.fonction) = $event)),
            placeholder: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.fonction]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "fonction" }, "Fonction", -1))
        ]),
        (_ctx.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.success), 1))
          : _createCommentVNode("", true),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn lg",
            disabled: _ctx.loading
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("img", {
              src: "/public/icons/icon-info-perso.svg",
              class: "btn-icon icon-white",
              alt: ""
            }, null, -1)),
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Enregistrer les modifications"))
              : (_openBlock(), _createElementBlock("span", _hoisted_14, "Enregistrement..."))
          ], 8, _hoisted_12)
        ])
      ], 32)
    ])
  ]))
}